import { render } from "./SiteHero.vue?vue&type=template&id=2e952cca&scoped=true"
import script from "./SiteHero.vue?vue&type=script&lang=js"
export * from "./SiteHero.vue?vue&type=script&lang=js"

import "./SiteHero.vue?vue&type=style&index=0&id=2e952cca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e952cca"]])

export default __exports__